import * as THREE from "three";
let renderer;
const isMobile =
  typeof navigator !== "undefined" &&
  (navigator.userAgent.match(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  ) ||
    navigator.maxTouchPoints > 1);
renderer = new THREE.WebGLRenderer({ antialias: !isMobile });
let width = window.innerWidth;
let height = window.innerHeight;
renderer.setSize(width, height);
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1;
renderer.outputEncoding = THREE.sRGBEncoding;
container.append(renderer.domElement);
export { renderer };
